import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'codeDesignation'
})
export class CodeDesignationPipeMock implements PipeTransform {

	transform(value: any, args?: any): any {
		return value;
	}

}
